<script>
import {
  CdrGrid,
} from '@rei/cedar';
import { LandingContentBlock } from '@rei/landing-content-block';
import LandingImageComponent from '@rei/landing-image-component';

export default {
  name: 'GreenlightLead',
  components: {
    CdrGrid,
    LandingContentBlock,
    LandingImageComponent,
  },
  props: {
    media: {
      type: Object,
      default: () => {},
    },
    content: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<template>
  <div
    class="greenlight-lead"
    data-ui="greenlight-lead"
  >
    <div class="greenlight-lead__wrapper">
      <cdr-grid
        class="greenlight-lead__grid"
      >
        <landing-content-block
          class="greenlight-lead__content"
          v-bind="content"
        />
        <div>
          <landing-image-component
            v-bind="media"
            :lazy-load="false"
            :use-resizing="false"
            fetch-priority="high"
            class="greenlight-lead__image"
          />
        </div>
      </cdr-grid>
    </div>
  </div>
</template>

<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';
.greenlight-lead {
  background: $cdr-color-background-secondary;

  &__wrapper {
    @include cdr-container;
    padding: $cdr-space-one-and-a-half-x;

    @include cdr-xs-mq-up {
      padding: $cdr-space-two-x;
    }
  }

  &__grid {
    grid-template-columns: 1fr;
    gap: 0 2rem;

    @include cdr-sm-mq-up {
      grid-template-columns: 1fr 1.52fr;
    }
  }

  &__content {
    align-self: center;
    padding: $cdr-space-inset-two-x;
  }
}
</style>
